import { IsOptional } from 'class-validator';

export class SearchFilter {
	@IsOptional()
	search: string;
}
